import { useMemo } from 'react';

import { useCloseWidget, useWidgetContext } from '@widget/core';

const MIN_PROGRESS = 0;
const MAX_PROGRESS = 100;
const FINAL_STEP_PROGRESS = 95;
const ROUND_TO = 5;

export function useProgress() {
  const { steps, history, activeId, maxNumberOfSteps } = useWidgetContext();
  const { isThankYouPageShown } = useCloseWidget();

  const progress = useMemo(() => {
    const activeStep = steps.find(({ id }) => id === activeId);
    const activeStepIndex = history.findIndex(({ id }) => id === activeId);

    if (!activeStep || activeStepIndex < 0) return MIN_PROGRESS;
    if (isThankYouPageShown) return MAX_PROGRESS;
    if (activeStepIndex > maxNumberOfSteps || activeStep.children?.props.finalStep)
      return FINAL_STEP_PROGRESS;

    const percentage = (activeStepIndex / maxNumberOfSteps) * FINAL_STEP_PROGRESS;
    return Math.floor(percentage / ROUND_TO) * ROUND_TO;
  }, [steps, history, activeId, maxNumberOfSteps, isThankYouPageShown]);

  return progress;
}
